export default "__VITE_ASSET__tLZ_PP2Y__"